import React, { createContext, useContext, useEffect, useState } from "react"; // Import React and hooks
import { Urls } from "./Urls"; // Import URLs from Urls file
import Axios from "./Axios"; // Import Axios instance
import { UserDataContext } from "./UserContext";
import { CompanyDetailsContext } from "./CompanyDetailsContext";

export const CompanyDataContext = createContext({});

export const CompanyDataProvider = ({ children }) => {
  const [companyData, setCompanyData] = useState({});
  const [orgs, setOrgs] = useState([]);
  // const [userData] = useContext(UserDataContext)
  const [companyName, companyID] = useContext(CompanyDetailsContext);

  const fetchCompanyDetails = () => {
    if (companyID && companyID !== undefined) {
      Axios.get(
        `${Urls.companyProfile}?company_id=${companyID}&projections_enable=procurement`
      )
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data[0] &&
            res.data[0].procurement &&
            res.data[0].procurement.upload_formats
          ) {
            const finalFormats = res.data[0].procurement.upload_formats.map(
              (org, index) => {
                org["format_no"] = `INP-${index + 1}`;
                return org;
              }
            );
            setCompanyData(finalFormats);
          }
        })
        .catch((err) => {
          console.error(err, "error");
        });
    }
  };

  const fetchOrgDetails = () => {
    if (companyID && companyID !== undefined) {
      Axios.get(
        `${Urls.companyProfile}?company_id=${companyID}&projections_enable=organizations`
      )
        .then((res) => {
          if (res && res.data && res.data.length > 0) {
            if (
              res.data[0].organizations &&
              res.data[0].organizations.length > 0
            ) {
              setOrgs(res.data[0].organizations);
            } else {
              setOrgs([]);
            }
          }
        })
        .catch((err) => {
          console.error(err, "error");
        });
    }
  };
  useEffect(() => {
    if (companyID && companyID !== undefined) {
      fetchCompanyDetails();
      fetchOrgDetails();
    }
  }, [companyID]);
  return (
    <CompanyDataContext.Provider
      value={{
        companyData,
        setCompanyData,
        fetchCompanyDetails,
        orgs,
        setOrgs,
      }}
    >
      {children}
    </CompanyDataContext.Provider>
  );
};

export function useUser() {
  return useContext(CompanyDataContext);
}
